
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/all/[id]",
      function () {
        return require("private-next-pages/all/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/all/[id]"])
      });
    }
  